var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 294,
    height: 1081,
    viewBox: "0 0 294 1081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 294,
    height: 1081,
    transform: "translate(924 243)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_4",
    x: 55.254,
    y: 0,
    width: 193.767,
    height: 1101.881,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -15,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(-924 -243)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 924, 243)",
    filter: "url(#Union_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4-2",
    "data-name": "Union 4",
    d: "M83.752,1080.88V498.811h-26.2v-57.02h60.462v53.254h-7.477V449.321H65.032v41.958h26.2v589.6ZM57.394,430.011V404.352a23.753,23.753,0,0,1,3.443-12.372A51.341,51.341,0,0,1,68.8,381.705c3.066-3.173,6.348-6.347,9.79-9.359,3.281-2.905,6.4-5.972,9.306-9.091a47.787,47.787,0,0,0,6.885-9.414,19.219,19.219,0,0,0,2.475-9.682,21.309,21.309,0,0,0-1.184-6.886,15.705,15.705,0,0,0-3.174-5.54,18.066,18.066,0,0,0-5.217-3.873,16.471,16.471,0,0,0-6.939-1.4,16.965,16.965,0,0,0-8.285,1.721,12.126,12.126,0,0,0-4.734,4.573,18.078,18.078,0,0,0-2.474,6.885,59.772,59.772,0,0,0-.7,8.822V352.6a24.785,24.785,0,0,0,.269,3.6l.645,4.25H1.235l-.322-3.335Q.59,354.111.32,351.367A57.341,57.341,0,0,1,0,345.181a61.138,61.138,0,0,1,6.724-28.724,64.875,64.875,0,0,1,18.5-21.678,85.913,85.913,0,0,1,27.7-13.556A121.682,121.682,0,0,1,83.752,276.6V0h7.476V284.073H87.464a116.458,116.458,0,0,0-32.383,4.3,77.868,77.868,0,0,0-25.336,12.372,57.833,57.833,0,0,0-16.407,19.2,54.008,54.008,0,0,0-5.863,25.228c0,1.883.107,3.659.269,5.379q.161,1.184.268,2.421H57.071v-4.519a61.719,61.719,0,0,1,.807-10.005,27.381,27.381,0,0,1,3.389-9.575,20.185,20.185,0,0,1,7.423-7.154,23.921,23.921,0,0,1,12.05-2.743,23.155,23.155,0,0,1,17.7,7.746,23.835,23.835,0,0,1,4.733,8.068,28.949,28.949,0,0,1,1.56,9.36,27.031,27.031,0,0,1-3.388,13.34,58.717,58.717,0,0,1-7.961,10.813,128.232,128.232,0,0,1-9.843,9.628c-3.281,2.905-6.456,5.918-9.36,8.93a46.807,46.807,0,0,0-6.886,8.93,15.881,15.881,0,0,0-2.42,8.553V422.48H109.84v-9.252c0-3.712,1.668-7.316,4.949-10.6a89.021,89.021,0,0,1,10.22-8.553q5.81-4.25,12.533-9.306a89.888,89.888,0,0,0,12.05-11.135,59.013,59.013,0,0,0,9.144-13.771,39.071,39.071,0,0,0,3.5-16.944,54.916,54.916,0,0,0-5.271-24.206,54,54,0,0,0-15.008-18.451,71.971,71.971,0,0,0-23.56-11.941l2.151-7.155A78.674,78.674,0,0,1,146.581,294.4a60.915,60.915,0,0,1,17.105,21.032,61.892,61.892,0,0,1,6.079,27.488,46.146,46.146,0,0,1-4.3,20.226,64.877,64.877,0,0,1-10.327,15.492,92.606,92.606,0,0,1-13.126,12.1q-6.724,5.111-12.587,9.36a78.625,78.625,0,0,0-9.306,7.8c-1.883,1.883-2.8,3.659-2.8,5.326v16.783Z",
    transform: "translate(79.26 0)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(956.238 690.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M634.14,740.466v-10.92a8.681,8.681,0,0,1,1.237-4.411,24.32,24.32,0,0,1,3.5-4.518c1.506-1.56,3.066-3.066,4.734-4.518,1.775-1.56,3.443-3.228,5-4.9a31.2,31.2,0,0,0,3.981-5.433,13.35,13.35,0,0,0,1.667-6.67,13.671,13.671,0,0,0-.753-4.626,12.1,12.1,0,0,0-2.367-4.034,11.574,11.574,0,0,0-8.822-3.873,12.257,12.257,0,0,0-5.971,1.345,10.37,10.37,0,0,0-3.712,3.6,13.017,13.017,0,0,0-1.667,4.734,31.536,31.536,0,0,0-.43,5.056v2.421H605.469q-.054-.7-.161-1.345-.107-1.291-.108-2.743a27.062,27.062,0,0,1,2.959-12.8A29.411,29.411,0,0,1,616.5,677.1a38.49,38.49,0,0,1,12.8-6.294,59.128,59.128,0,0,1,16.46-2.205,55.056,55.056,0,0,1,15.653,2.152,37.841,37.841,0,0,1,11.942,6.078,27.314,27.314,0,0,1,7.585,9.414,27.015,27.015,0,0,1,2.69,12.265,19.922,19.922,0,0,1-1.775,8.66,30.614,30.614,0,0,1-4.626,6.939,43.134,43.134,0,0,1-6.132,5.648q-3.389,2.582-6.347,4.734a49.685,49.685,0,0,0-5.11,4.25,7.645,7.645,0,0,0-2.474,5.272v6.455Z",
    transform: "translate(-605.2 -668.6)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>",
    transform: "translate(29.048 83.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M659.2,845.317V823.8h23.292v21.517Z",
    transform: "translate(-659.2 -823.8)",
    fill: "#344d99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(1113.149 399.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M925.894,199.266V188.292a8.828,8.828,0,0,1,1.237-4.411,26.216,26.216,0,0,1,3.5-4.519c1.506-1.506,3.066-3.012,4.734-4.519q2.663-2.34,5-4.841a31.2,31.2,0,0,0,3.981-5.433,13.35,13.35,0,0,0,1.667-6.67,14.628,14.628,0,0,0-.753-4.626,11.75,11.75,0,0,0-6.132-6.832,10.922,10.922,0,0,0-5.056-1.076,12.032,12.032,0,0,0-6.025,1.345,10.08,10.08,0,0,0-3.658,3.55,13.726,13.726,0,0,0-1.721,4.787,31.523,31.523,0,0,0-.377,5.056v2.421H897.223q-.108-.7-.161-1.345a22.99,22.99,0,0,1-.161-2.743,27.09,27.09,0,0,1,3.012-12.8,29.067,29.067,0,0,1,8.338-9.79,39.466,39.466,0,0,1,12.8-6.24,59.016,59.016,0,0,1,16.406-2.205,54.782,54.782,0,0,1,15.653,2.152,35.5,35.5,0,0,1,12,6.078,27.129,27.129,0,0,1,7.585,9.36,27.968,27.968,0,0,1,2.69,12.318,19.845,19.845,0,0,1-1.775,8.607,28.4,28.4,0,0,1-4.68,6.993,46.137,46.137,0,0,1-6.078,5.648q-3.389,2.528-6.347,4.68a45.331,45.331,0,0,0-5.11,4.3,7.314,7.314,0,0,0-2.474,5.218v6.509Z",
    transform: "translate(-896.9 -127.4)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>",
    transform: "translate(29.101 83.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M951,304.071V282.5h23.292v21.571Z",
    transform: "translate(-951 -282.5)",
    fill: "#344d99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>",
    transform: "translate(993.517 453.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M690.368,266.922v-5.971a4.368,4.368,0,0,1,.7-2.421A12.227,12.227,0,0,1,693,256.056q1.183-1.237,2.582-2.474a31.271,31.271,0,0,0,2.69-2.636,15.938,15.938,0,0,0,2.205-3.012,6.979,6.979,0,0,0,.915-3.658,7.645,7.645,0,0,0-.43-2.528,6.5,6.5,0,0,0-1.291-2.205,5.967,5.967,0,0,0-2.044-1.56,6.276,6.276,0,0,0-2.743-.592,7.633,7.633,0,0,0-3.335.753,5.3,5.3,0,0,0-1.99,1.99,6.718,6.718,0,0,0-.914,2.582,18.363,18.363,0,0,0-.215,2.8V246.8H674.661a5.323,5.323,0,0,1-.054-.753,9.536,9.536,0,0,1-.108-1.452,14.509,14.509,0,0,1,1.668-7.047,15.839,15.839,0,0,1,4.519-5.325,22.075,22.075,0,0,1,7.047-3.443,31.835,31.835,0,0,1,8.983-1.183,28.956,28.956,0,0,1,8.607,1.183,19.489,19.489,0,0,1,6.509,3.281,14.837,14.837,0,0,1,4.2,5.164,15.248,15.248,0,0,1,1.506,6.724,10.945,10.945,0,0,1-1.022,4.734,15.2,15.2,0,0,1-2.528,3.819,22.318,22.318,0,0,1-3.335,3.066q-1.883,1.452-3.5,2.582a27.658,27.658,0,0,0-2.8,2.367,4.06,4.06,0,0,0-1.345,2.9v3.5Z",
    transform: "translate(-674.5 -227.6)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_9",
    "data-name": "<Group>",
    transform: "translate(15.922 45.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M704.1,324.38V312.6h12.8v11.78Z",
    transform: "translate(-704.1 -312.6)",
    fill: "#344d99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_10",
    "data-name": "<Group>",
    transform: "translate(1116.539 756.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_11",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M940.478,883.614v-14.04a10.906,10.906,0,0,1,1.614-5.7,31.068,31.068,0,0,1,4.465-5.81c1.936-1.936,3.98-3.927,6.132-5.809a87.861,87.861,0,0,0,6.4-6.24,36.268,36.268,0,0,0,5.11-6.993,17.326,17.326,0,0,0,2.152-8.607,18.76,18.76,0,0,0-.968-5.971,15.917,15.917,0,0,0-3.012-5.164,15.406,15.406,0,0,0-4.841-3.6,16.849,16.849,0,0,0-14.255.377,13.319,13.319,0,0,0-4.734,4.572,17.367,17.367,0,0,0-2.206,6.132,43.654,43.654,0,0,0-.484,6.509v3.12H903.577q-.108-.915-.215-1.775-.161-1.668-.161-3.5a35.194,35.194,0,0,1,3.819-16.46,38.665,38.665,0,0,1,10.7-12.587,51.329,51.329,0,0,1,16.514-8.015,75.517,75.517,0,0,1,21.14-2.851A67.615,67.615,0,0,1,975.5,794a46.054,46.054,0,0,1,15.384,7.8,34.725,34.725,0,0,1,9.79,12.049,35.388,35.388,0,0,1,3.5,15.815,25.639,25.639,0,0,1-2.313,11.081,38.425,38.425,0,0,1-5.971,8.983,52.4,52.4,0,0,1-7.854,7.262q-4.357,3.281-8.176,6.078a55.976,55.976,0,0,0-6.563,5.541,9.5,9.5,0,0,0-3.174,6.724v8.284Z",
    transform: "translate(-903.2 -791.2)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_12",
    "data-name": "<Group>",
    transform: "translate(37.385 107.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M972.7,1018.5V990.8h29.962v27.7Z",
    transform: "translate(-972.7 -990.8)",
    fill: "#344d99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_13",
    "data-name": "<Group>",
    transform: "translate(924.125 563.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_14",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M564.542,479.529v-7.208a5.453,5.453,0,0,1,.807-2.851,16.314,16.314,0,0,1,2.259-3.012c1.022-.968,2.044-1.99,3.12-2.959,1.183-1.022,2.259-2.1,3.281-3.174a18.151,18.151,0,0,0,2.636-3.6,9.169,9.169,0,0,0,1.076-4.357,9.962,9.962,0,0,0-.484-3.066,7.784,7.784,0,0,0-1.56-2.636,7.94,7.94,0,0,0-2.474-1.829,7.469,7.469,0,0,0-3.281-.7,7.938,7.938,0,0,0-3.981.861,6.667,6.667,0,0,0-2.421,2.367,9.214,9.214,0,0,0-1.13,3.12,33.049,33.049,0,0,0-.269,3.335s.054,1.506.054,1.56H545.661l-.108-.861q-.054-.861-.054-1.829a18.025,18.025,0,0,1,1.936-8.392,19.474,19.474,0,0,1,5.487-6.4,25.8,25.8,0,0,1,8.445-4.142,37.711,37.711,0,0,1,10.758-1.452,34.111,34.111,0,0,1,10.274,1.452,22.986,22.986,0,0,1,7.854,3.981,17.734,17.734,0,0,1,5,6.132,18.357,18.357,0,0,1,1.775,8.123,12.633,12.633,0,0,1-1.183,5.648,20.4,20.4,0,0,1-3.012,4.572,28.943,28.943,0,0,1-4.034,3.712q-2.259,1.668-4.142,3.12a27.619,27.619,0,0,0-3.389,2.8,4.895,4.895,0,0,0-1.614,3.443v4.25Z",
    transform: "translate(-545.5 -432.3)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_15",
    "data-name": "<Group>",
    transform: "translate(19.096 54.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M581,548.447V534.3h15.277v14.147Z",
    transform: "translate(-581 -534.3)",
    fill: "#344d99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_16",
    "data-name": "<Group>",
    transform: "translate(1159.948 640.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_17",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M1002.942,623.175v-7.154a5.64,5.64,0,0,1,.807-2.9,13.007,13.007,0,0,1,2.313-2.958,41.542,41.542,0,0,1,3.12-3.012c1.13-1.022,2.205-2.1,3.228-3.174a17.845,17.845,0,0,0,2.636-3.55,8.826,8.826,0,0,0,1.13-4.411,9.057,9.057,0,0,0-.538-3.066,7.786,7.786,0,0,0-1.56-2.636,8.142,8.142,0,0,0-2.421-1.829,7.825,7.825,0,0,0-3.335-.7,8.066,8.066,0,0,0-3.981.914,6.8,6.8,0,0,0-2.421,2.313,8.945,8.945,0,0,0-1.076,3.12,20.911,20.911,0,0,0-.269,3.335v1.614H984.061a7.373,7.373,0,0,0-.054-.914,14.294,14.294,0,0,1-.108-1.775,18.09,18.09,0,0,1,1.936-8.445,20.128,20.128,0,0,1,5.487-6.4,25.205,25.205,0,0,1,8.445-4.088A37.98,37.98,0,0,1,1010.527,576a36.609,36.609,0,0,1,10.328,1.4,24.009,24.009,0,0,1,7.854,3.981,18.032,18.032,0,0,1,5,6.186,18.686,18.686,0,0,1,1.721,8.069,13.229,13.229,0,0,1-1.13,5.648,21.219,21.219,0,0,1-3.066,4.572,26.207,26.207,0,0,1-4.034,3.712q-2.206,1.721-4.142,3.12a33.612,33.612,0,0,0-3.389,2.8,4.895,4.895,0,0,0-1.614,3.443v4.25Z",
    transform: "translate(-983.9 -576)",
    fill: "#344d99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_18",
    "data-name": "<Group>",
    transform: "translate(19.096 54.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M1019.4,692.047V677.9h15.331v14.147Z",
    transform: "translate(-1019.4 -677.9)",
    fill: "#344d99"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqImg);
export default __webpack_public_path__ + "static/media/faqImg.b20e4eac063b10a44e57fdb0430896ff.svg";
export { ForwardRef as ReactComponent };